// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock_textBlock__3DSFl","texts":"TextBlock_texts__ZW-EU","textItem":"TextBlock_textItem__3gjHA"};